import React from "react";
import moment from 'moment';
import { component_tool,utils_tool } from "@/tool";
let { WizModal } = component_tool;
let { $$,checkStrLength } = utils_tool;
//配置接口项
let componentName = 'trainPathCommentManagement';
let ref;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
};
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "delFlag",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "名称",
    name: "searchName",
    searchItem: {}
  },
  {
    title: "名称",
    name: "name",
    tableItem: {
      width: 500,
    }
  },
  {
    title: "管理范围",
    name: "manageTargetScopeName",
    tableItem: {
      width: 600,
    }
  },
  {
    title: "状态",
    name: "state",
    dict: [
      { code: 1, codeName: "草稿" },
      { code: 2, codeName: "已发布" },
      { code: 3, codeName: "已关闭" }
    ],
    tableItem: {
      width: 100,
    },
    searchItem: {
      type: "select"
    }
  },
  {
    title: '创建时间',
    name: 'createTime',
    dataIndex: "createTime",
    tableItem: {
      // width: 150,
      render: text => {
        return formatterDate(text)
      }
    },
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        collapse: false,
        // cols: {
        //   xs: 12,
        //   md: 12,
        //   xl: 12
        // },
        //若查询数据需要额外处理 请在此处进行
        // dataFormat:(v)=>{
        //   let _v = v;
        //   if (v && v['typeList'] && v['typeList'].length) {
        //     _v.typeList = v.typeList.map(select=>select.key);//获取对应分类的id
        //   }else{
        //     _v.typeList = [];
        //   }
        //   return _v
        // },

        buttonSort: ['add'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增', type: 'primary' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/comment/trainPathCommentAdd'
              }
            }
          },
          {
            key: "delete",
            custom: true,
            needSelect: true,
            params: {icon: "delete", children: "删除", type: "danger"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "delete",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (!rows) return;
                if ($$.isArray(rows) && !rows.length) return;
                // const content = `删除后数据不可恢复，您确定要删除这${
                //   $$.isArray(rows) ? rows.length : ""
                // }条评语吗？`;
                const content = '删除后数据不可恢复，您确定要删除选中的评语吗？'
                let ids = [];
                rows.forEach(e => {
                  if (e['rowKey']){
                    ids.push(e['rowKey']);
                  }
                });
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ids
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
        ]
      },
      modalFormProps: {
        key: "modal123",
        params: {
          modalParams: {
            title: "Modal",
            children: "Bla bla123 .."
          }
        }
      },
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false,
      },
      rowOperateSort: ['look', 'update', 'releaseOrClose','commentReviewManagement'],
      rowOperateView: [
        {
          key: "commentReviewManagement",
          custom: true,
          params: { children: "评语审核管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/comment/trainPathCommentAudit"
            }
          }
        },
        {
          key: "releaseOrClose",
          custom: true,
          params: { children: "发布"},
          textFormat: {
            recordKey: 'state',
            dirt: { 1: '发布', 3: '发布', 2: '关闭' }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateState",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              let statusNameStr = record['state'] === 1 || record['state'] === 3 ? "发布" : "关闭";
              const content = `您确定要` + statusNameStr + `该评语？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 1 || record['state'] === 3 ? 2 : 3,
                    ids: [record['id']]
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "update",
          custom: true,
          params: { children: "编辑" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/comment/trainPathCommentUpd"
            }
          }
        },
        {
          key: "look",
          custom: true,
          params: { children: "查看" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/comment/lookComment"
            }
          }
        },
      ],
      commonOperate: {
        add: true,
        delete: false,
        update: true,
        look: true

      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/pageList`,
    payload: {
      key: `${componentName}@pageList`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  updateState: {
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  }
}


let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
